import { Injectable } from '@angular/core';
import * as forEach from 'lodash/forEach';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class AppFunctionsService {

  constructor() { }

  getFormStructure(form: UntypedFormGroup, formFields) {
    forEach(formFields, (value, key) => {
      if (value && value.formFields) {
        form.addControl(key, new UntypedFormGroup({}))
        this.getLevelOneFormStructure(form, value.formFields, key);
      }
      form.addControl(key, new UntypedFormControl(null));
    })
  }

  getLevelOneFormStructure(form: UntypedFormGroup, formFields, levelOneKey) {
    forEach(formFields, (value, key) => {
      if (value && value.formFields) {
        form.controls[levelOneKey]['addControl'](key, new UntypedFormGroup({}))
        this.getLevelTwoFormStructure(form, value.formFields, levelOneKey, key);
      }
      form.controls[levelOneKey]['addControl'](key, new UntypedFormControl(null));
    })
  }

  getLevelTwoFormStructure(form: UntypedFormGroup, formFields, levelOneKey, levelTwoKey) {
    forEach(formFields, (value, key) => {
      form.controls[levelOneKey]['controls'][levelTwoKey]['addControl'](key, new UntypedFormControl(null));
    })
  }
}
